import { useNavigate } from "react-router-dom";
import AuthCard from "@/components/auth/AuthCard";
import AuthButton from "@/components/auth/AuthButton";
import { useAuth } from "@/context/AuthContext";

// TrialExpired — hard stop. Cannot bypass, no nav back into the app.
// Buy Basic → /auth/purchase-basic. Log Out → clear session + /auth/login.
export default function TrialExpired() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/auth/login", { replace: true });
  };

  return (
    <AuthCard
      title="Your trial has ended"
      subtitle="To continue using CDI Collectables, you must buy Basic. Premium is optional."
    >
      <AuthButton
        onClick={() => navigate("/auth/purchase-plan")}
        testid="trial-expired-choose-plan"
      >Choose plan</AuthButton>
      <div className="mt-3">
        <AuthButton
          variant="charcoal"
          onClick={onLogout}
          testid="trial-expired-logout"
        >Log out</AuthButton>
      </div>
    </AuthCard>
  );
}
